import { client } from './setup';
import { CATEGORIES_API } from '../globals';

export default {
    getCategories: (params) => client.get(CATEGORIES_API, { params }),
    getCategory: (id) => client.get(`${CATEGORIES_API}/${id}`),
    createCategory: (category) => client.post(CATEGORIES_API, category),
    updateCategory: (category) => client.put(`${CATEGORIES_API}/${category.id}`, category),
    deleteCategory: (id, params) => client.delete(`${CATEGORIES_API}/${id}`, { params }),
}